import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaUserShield, FaLayerGroup, FaBookOpen, FaTasks,
  FaTags, FaSitemap, FaProjectDiagram, FaBoxes, FaBuilding, FaGlobeAsia, FaMapMarkedAlt, FaCity, FaPercent,FaUsers,FaChartLine,FaUsersCog,FaFolderOpen 
} from 'react-icons/fa';

const settingSections = [
  {
    title: 'General Settings',
    items: [
      { title: 'Role', icon: <FaUserShield />, path: '/role' },
      { title: 'Responsibility', icon: <FaTasks />, path: '/responsibility' },
      { title: 'Cluster', icon: <FaLayerGroup />, path: '/cluster' },
      { title: 'Chapter', icon: <FaBookOpen />, path: '/chapter' },
    ],
  },
  {
    title: 'Business Settings',
    items: [
      { title: 'BusinessFormation', icon: <FaBuilding />, path: '/businessFormation' },
      { title: 'Business Type', icon: <FaTags />, path: '/businessType' },
      { title: 'Business Category', icon: <FaSitemap />, path: '/businessCategory' },
      { title: 'Business Sub-category', icon: <FaProjectDiagram />, path: '/businessSubCategory' },
      { title: 'Business Product & Service', icon: <FaBoxes />, path: '/businessProductservice' },
    ],
  },
  {
    title: 'Event Settings',
    items: [
      { title: 'Event Type', icon: <FaTags />, path: '/eventType' },
      { title: 'Event Venue', icon: <FaSitemap />, path: '/vanue' },
    ],
  },
  {
    title: 'Other Settings',
    items: [
      { title: 'Country', icon: <FaGlobeAsia />, path: '/country' },
      { title: 'State', icon: <FaMapMarkedAlt />, path: '/state' },
      { title: 'City', icon: <FaCity />, path: '/city' },
      { title: 'Tax', icon: <FaPercent />, path: '/tax' }, 
    ],
  },
  {
    title: 'Team Settings',
    items: [
      { title: 'Contribution Level', icon: <FaChartLine />, path: '/contributionLeval' },
      { title: 'Core Team', icon: <FaUsersCog />, path: '/core' },
      { title: 'Team', icon: <FaUsers />, path: '/team' },
    ],
  },
  {
    title: 'App Settings',
    items: [
     { title: 'Pdf-Category', icon: <FaFolderOpen />, path: '/pdfCategory' },
    ],
  },
];

const Setting = () => { 
  return (
    <div className="container">
      <h3 className="mb-2">Settings</h3>

      {settingSections.map((section, idx) => (
        <div key={idx} className="mb-4">
          <h5 className="mb-3 text-center">{section.title}</h5>
          <div className="row">
            {section.items.map((item, index) => (
              <div key={index} className="col-sm-2 mb-2">
                <NavLink to={item.path} className="text-decoration-none">
                  <div className="card text-center p-3 shadow-sm border h-100">
                    <div className="text-primary-custom fs-4 mb-2">{item.icon}</div>
                    <h6 className="mb-0 text-dark">{item.title}</h6>
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Setting;
